
import Event = createjs.Event;

export class Poker2BuddyEvent extends Event {
    public static CHANGE_ONLINESTATE: string = "changeonlinestate";
    public static CHANGE_BUDDYDATA: string = "changebuddydata";
    public static ADD_FRIEND: string = "addfriend";
    public static GIVE_CHIPS: string = "givechips";
    public static INVITE_FRIEND_FAILD: string = "inviteFriendFaild";
    public static INVITE_FRIEND_COMPLETE: string = "inviteFriendComplete";

    public params: any[];

    constructor(type: string, params: any[] = null, bubbles: boolean = false, cancelable: boolean = false) {
        super(type, bubbles, cancelable);

        this.params = params;
    }
}
